import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, FormControl, FormLabel, NumberInputStepper, Stack, Select, NumberInput, NumberInputField, NumberIncrementStepper, NumberDecrementStepper } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { getAPIEndpoint } from "views/config";
import axios from "axios";
import { logger } from "views/models/logging";
import { ToastContainer, toast } from 'react-toastify';

export function EditTopup({ isOpen = false, onClose = null, topupData, refreshData, clients = [], creator, authKey }) {
    const initialRef = useRef(null);
    const [id, setId] = useState(null);
    const [client, setClient] = useState('');
    const [amount, setAmount] = useState();
    const [isLoading, setIsloading] = useState(false);

    useEffect(() => {
        setId(topupData.id)
        setClient(topupData.agentId);
        setAmount(topupData.amount);
    }, [topupData]);

    const editTopUp = async () => {
        setIsloading(true);

        const params = {
            id,
            agentId: client,
            amount,
            creator
        };

        const apiHeader = {
            headers: {
                "authorization": `Bearer ${authKey}`
            }
        }

        try {
            const response = await axios.post(getAPIEndpoint('topup-edit'), params, apiHeader);
            if (response) {
                const { status, data } = response.data;
                if (status === 'success' && data) {
                    refreshData(authKey);
                    setIsloading(false);
                    onClose();
                }
                else {
                    toast.error("Sorry, we are unable to edit top-up at this time. Please try again later.");
                }
            }
        } catch (error) {
            toast.error("Sorry, we are unable to add top-up at this time. Please try again later.");
            await logger({ task: "Edit top-up", error: error.toString() });
        }

        setIsloading(false);
    }

    const closeModal = () => {
        //clear();
        onClose();
    }

    const processForm = async (e) => {
        e.preventDefault();
        await editTopUp();
    }

    return (
        <>
            <Modal isCentered initialFocusRef={initialRef} closeOnOverlayClick={false} isOpen={isOpen} onClose={closeModal}>
                <ModalOverlay />
                <ModalContent>
                    <form onSubmit={processForm}>
                        <ModalHeader>Edit Top-up</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={2} >
                            <div style={{ overflow: 'auto', maxHeight: '60vh' }}>
                                <FormControl isRequired mt={2}>
                                    <FormLabel>Select Client</FormLabel>
                                    <Select ref={initialRef} value={client} onChange={e => setClient(e.target.value)}>
                                        <option key='0' value={null}></option>
                                        {clients.map((c, k) => <option key={k + 1} value={c.agentId}>{c.agentName}</option>)}
                                    </Select>
                                </FormControl>

                                <FormControl isRequired mt={5}>
                                    <FormLabel>Amount</FormLabel>
                                    <NumberInput size='md' value={amount} onChange={v => setAmount(v)}>
                                        <NumberInputField />
                                        <NumberInputStepper>
                                            <NumberIncrementStepper />
                                            <NumberDecrementStepper />
                                        </NumberInputStepper>
                                    </NumberInput>
                                </FormControl>
                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <Stack direction={'row'}>
                                <Button onClick={closeModal}>Cancel</Button>
                                <Button isLoading={isLoading} type="submit" bgColor='#0C7FE9' color='white' _hover={{
                                    bg: "#3c98ed"
                                }} mr={3}>
                                    Update
                                </Button>
                            </Stack>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>
            <ToastContainer />
        </>
    )
}